<template>
  <div class="x-misscenlist-box" style="margin:15px">
    <!-- <div class="x-miss-addbox"><el-button type="primary" @click="uploadper"  style="padding:15px;"><span class="x-ac-addbtn"></span>下载</el-button></div> -->
    <div class="" style="text-align: left;">
      <a @click="uploadper" :href="turl" class="x-perbtn-up">下载个人资料</a>
    </div>
    <div class="">
      <!--  -->
      <div class="x-perdes-tabbox">
        <div class="x-perdes-info">
          <div class="x-perdes-l">姓名：</div>
          <div class="x-perdes-r">{{infoname}}</div>
          <div class="x-perdes-l">性别：</div>
          <div class="x-perdes-r">{{infogender}}</div>
          <div class="x-perdes-l">手机号：</div>
          <div class="x-perdes-r">{{infophone}}</div>
        </div>
        <div class="x-perdes-info">
          <div class="x-perdes-l">职位：</div>
          <div class="x-perdes-r">{{infoder}}</div>
          <div class="x-perdes-l">入职时间：</div>
          <div class="x-perdes-r">{{infotime}}</div>
          <div class="x-perdes-l">区域店面信息</div>
          <div class="x-perdes-r">{{region}}</div>
        </div>
      </div>

      <!--  -->
      <div class="x-perdesc-rotit">职位变更记录</div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="date" label="职位" width="">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.log }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="时间" width="">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ timechangetime(scope.row.create_at) }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!--  -->
      <div class="x-perdesc-rotit">个人课程完成数据</div>
      <el-table :data="tableData2" border style="width: 100%">
        <el-table-column prop="date" label="课程名称" width="">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="是否学完" width="">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.is_study }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="是否考完" width="">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.is_exam }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="是否一次通过" width="">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.is_once }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!--  -->
      <div class="x-perdesc-rotit">个人任务完成数据</div>
      <el-table :data="tableData3" border style="width: 100%">
        <el-table-column prop="date" label="任务名称" width="">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="观看进度" width="">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.study }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="考试进度" width="">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.exam }}</span>
          </template>
        </el-table-column>
      </el-table>
      <!--  -->
      <div class="x-perdesc-rotit">个人考核完成数据</div>
      <el-table :data="tableData4" border style="width: 100%">
        <el-table-column prop="date" label="考核标题" width="">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="考试分数" width="">
          <template slot-scope="scope">
            <span style="margin-left: 10px">{{ scope.row.score }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>

  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'persondesc',
  data () {
    return {
      thisid:'',
      turl:'',
      tableData:[],
      infoname:'',
      infogender:'',
      infophone:'',
      infoder:'',
      infotime:'',
      tableData2:[],
      tableData3:[],
      tableData4:[],
      region:''

    }
  },
  created() {
    console.log('id：'+this.$route.params.id);
  },
  mounted(){
    this.seepersondesc(this.$route.params.id)
    this.thisid = this.$route.params.id;
  },
  methods:{
    // 时间戳转时间
    timechangetime(timers){
      var date = new Date((parseInt(timers) + 8 * 3600) * 1000).toJSON().substr(0, 19).replace('T', ' ').replace(/-/g, '-');
      return date
    },
    //查看个人资料
    seepersondesc:function(id){
      axios.get('/admin/member/info', {
        params: {
          sec: localStorage.token,
          id:id
        }
      })
      .then(function (response) {
        console.log(response);
        if(response.data.status == 1){
              this.infoname = response.data.info.username;
              if(response.data.info.gender==1){
                this.infogender = '男'
              }else{
                this.infogender = '女'
              };
              this.infophone = response.data.info.phone;
              this.infoder = response.data.info.bread;
              this.infotime = response.data.info.entry_date;
              this.region = response.data.info.region;
              //
              this.tableData = response.data.jobs;
              this.tableData2 = response.data.courses;
              this.tableData3 = response.data.tasks;
              this.tableData4 = response.data.exams;
        }else{
          this.$message({
            showClose: true,
            message:response.data.msg ,
            type: 'error'
          });
        }
      }.bind(this))
      .catch(function (error) {
        console.log(error);
      });
    },
    uploadper:function(){
      this.turl = "http://peixun.dlbbdk.com/admin/member/xls?sec=" + localStorage.token + "&id=" + this.thisid
      console.log(this.turl);
    },

  }
}
</script>
<style media="screen">
  .x-perbtn-up{
    text-decoration: none;
    color: #BDA17A;
    border: 1px solid #BDA17A;
    padding: 10px 26px;
    border-radius: 7px;
  }a.x-perbtn-up:hover{
    background-color: #BDA17A;
    color: #fff;
  }.x-perdes-info{
    display: flex;
    border: 1px solid #f5f5f5;
    text-align: left;
  }.x-perdes-l,.x-perdes-r{
    flex: 1;
    padding: 10px;
  }.x-perdes-l{
    /* background-color: #f5f5f5; */
    padding: 10px;
    color: #BDA17A;
    border-right: 1px solid #f5f5f5;
  }.x-perdes-tabbox{
    margin: 40px 0;
  }.x-perdes-tabbox .x-perdes-info:last-child{
    border-top: 0;
  }.x-perdesc-rotit{
    text-align: left;
    color: #BDA17A;
    margin: 12px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/persondesc.vue